import { render, staticRenderFns } from "./InstructionVideo.vue?vue&type=template&id=8a26d260&"
import script from "./InstructionVideo.vue?vue&type=script&lang=js&"
export * from "./InstructionVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports